import { Fragment, useEffect, useRef, useState } from "react";
import {
  OrderFilterButtons,
  OrderStatusButtons,
  extentions,
} from "../../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrdersOfStore,
  updateOrderStatus,
  updateOrderInvoice,
} from "../../../redux/Thunk/Order/OrderThunks";
import Pagination from "../../common/Pagination";
import { Form, Formik } from "formik";
import CheckedBg from "../../common/icons/CheckedBg";
import {
  cancelOrder,
} from "../../../redux/Thunk/Store/StoreThunks";
import Loader from "../../Loader";
import { debounce } from "lodash";
import { createOrderValidation } from "../../common/Validation/createOrderValidation";
import {
  setActiveForm,
} from "../../../redux/Reducer/Admin/PartnerSlice";
import { setOrderById } from "../../../redux/Reducer/Order/OrderSlice";
import toast from "react-hot-toast";
import CreateOrder from "../../common/icons/CreateOrder";
import DobbleCheck from "../../common/icons/DobbleCheck";
import Shipping from "../../common/icons/Shipping";
import Packed from "../../common/icons/Packed";
import Complete from "../../common/icons/Complete";
import { setLoading } from "../../../redux/Reducer/Store/StoreSlice";
import ArrowDown from "../../common/icons/ArrowDown";
import { frequentProductList, fetchNRxDrugs } from "../../../redux/Thunk/Product/ProductThunks";
import { getProductRowTags } from "../../../utils/helpers";
import StoreSidebarToggle from "../StoreSidebarToggle";
import pincodeData from "../../../utils/pincodeCityDirectory.json";
import UPIPaymentModal from "../../Doctor/Tracking/UPIPaymentModal";
import ConfirmationModal from "../../Doctor/Tracking/ConfirmationModal";
import apiAxios from "../../../services/apiAxios";
import {
  fetchStoreQuickOrders,
  cancelQuickOrder,
} from "../../../redux/Thunk/QuickOrder/QuickOrderThunks";
import { setActiveQuickOrder } from "../../../redux/Reducer/QuickOrder/QuickOrderSlice";

// Create indexed map for O(1) pincode lookups to maintain performance
const pincodeMap = pincodeData.reduce((acc, curr) => {
  if (!acc[curr.pincode]) acc[curr.pincode] = curr;
  return acc;
}, {});

// Helper to resolve full location details from the directory
const resolveLocationDetails = (pincode, city) => {
  if (pincode) {
    const match = pincodeMap[String(pincode)];
    if (match) return `${match.area}, ${match.city}, ${match.state}`;
  }
  if (city) {
    // City lookup is slower but rare as a primary fallback
    const match = pincodeData.find(d => String(d.city).toLowerCase() === String(city).toLowerCase());
    if (match) return `${match.city}, ${match.state}`;
  }
  return null;
};

const initialValues = {
  products: [
    {
      typeIndex: "",
      morningTime: 0,
      midDay: 0,
      eveningTime: 0,
      night: 0,
      takenTime: "A/F",
      takenTimeIndex: "",
      extra: 0,
      extraIndex: 0,
    },
  ],
};
function Orders({ onToggleEditor }) {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState("all");
  const [filterByStatus, setFilterByStatus] = useState("all");
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [initialFormValues, setInitialFormValues] = useState(initialValues);
  const [orderViewStates, setOrderViewStates] = useState({});
  const [counts, setCounts] = useState({
    all: 0,
    clinic: 0,
    collect: 0,
    address: 0,
  });
  const [statusCounts, setStatusCounts] = useState({
    all: 0,
    accept: 0,
    packed: 0,
    dispatched: 0,
    delivered: 0,
    cancelled: 0,
    collected: 0,
  });
  const [invoiceData, setInvoiceData] = useState({});
  const [selectedPayment, setSelectedPayment] = useState([]);
  const [selectedAddressOrder, setSelectedAddressOrder] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [orderToCancel, setOrderToCancel] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [showStateFilters, setShowStateFilters] = useState(false);
  const [paymentModalInfo, setPaymentModalInfo] = useState({ isOpen: false, orderId: null, amount: 0 });
  const [confirmModalState, setConfirmModalState] = useState({ isOpen: false, orderId: null });

  // Quick Order state
  const storeQuickOrders = useSelector((state) => state.quickOrder?.storeQuickOrders || []);
  const [qoCancelTarget, setQoCancelTarget] = useState(null);
  const [qoCancelReason, setQoCancelReason] = useState("");

  const { storeDetail } = useSelector((state) => state?.store);
  const notificationPopup = useSelector((state) => state?.store?.notification);
  const products = useSelector((state) => state?.product?.frequentProduct);
  const nrxDrugNames = useSelector((state) => state?.product?.nrxDrugNames || []);
  const detailsRef = useRef(null);

  const {
    storeOrders: data,
    loading,
    invoiceDetails,
  } = useSelector((state) => state?.order);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (openDropdownId && !e.target.closest('.payment-dropdown-container')) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openDropdownId]);

  const getPayload = (selected, filterByStatus) => {
    const validAddressTypes = {
      all: "",
      clinic: "isClinic",
      collect: "isCollect",
      address: "isAddress",
    };

    const validOrderTypes = {
      all: "",
      accept: "isAccepted",
      packed: "isPacked",
      dispatched: "isDispatched",
      delivered: "isDelivered",
      cancelled: "isCancelled",
      collected: "isCollected",
    };
    return {
      addressType: validAddressTypes[selected] || "",
      orderType: validOrderTypes[filterByStatus] || "",
    };
  };
  const updatedOrderFilterButtons = OrderFilterButtons?.map((button) => ({
    ...button,
    count: counts[button.value]?.toString()?.padStart(2, "0"),
  }));

  // const updatedOrderStatusButtons = OrderStatusButtons?.map((button) => ({
  //   ...button,
  //   count: statusCounts[button.value]?.toString()?.padStart(2, "0"),
  // }));
  const updatedOrderStatusButtons = OrderStatusButtons?.filter((button) => {
    if (selected === "collect" && button.value === "dispatched") {
      return false;
    }
    return true;
  })?.map((button) => {
    if (selected === "collect" && button.value === "delivered") {
      return {
        ...button,
        label: "Collected",
        value: "collected",
        count: statusCounts["collected"]?.toString()?.padStart(2, "0") || "00",
      };
    }
    return {
      ...button,
      count: statusCounts[button.value]?.toString()?.padStart(2, "0"),
    };
  });

  useEffect(() => {
    const payload = getPayload(selected, filterByStatus);

    if (payload && Object.keys(payload).length > 0) {
      setCurrentPage(1);
    }
    if (filterByStatus === "collected" && selected !== "collect") {
      setFilterByStatus("delivered");
    } else if (
      (filterByStatus === "delivered" || filterByStatus === "dispatched") &&
      selected === "collect"
    ) {
      setFilterByStatus("collected");
    }
  }, [selected, filterByStatus]);
  useEffect(() => {
    dispatch(fetchNRxDrugs());
    const id = storeDetail?.store?.SID;
    if (!products?.frequentProducts?.length && id !== undefined) {
      // dispatch(fetchFrequentProducts(id));
      let search = "";
      dispatch(frequentProductList({ id, productName: search }));
    }
  }, [storeDetail?.store?.SID, dispatch, products?.frequentProducts?.length]);

  useEffect(() => {
    if (data && data?.orders) {
      const newCounts = {
        all: data?.counts?.total,
        clinic: data?.counts?.isClinic,
        collect: data?.counts?.isCollect,
        address: data?.counts?.isAddress,
      };
      const newStatusCounts = {
        all: data?.counts?.all,
        accept: data?.counts?.isAccepted,
        packed: data?.counts?.isPacked,
        dispatched: data?.counts?.isDispatched,
        delivered: data?.counts?.isDelivered,
        cancelled: data?.counts?.isCancelled,
        collected: data?.counts?.isCollected,
      };
      setCounts(newCounts);
      setStatusCounts(newStatusCounts);
    }
  }, [data]);

  useEffect(() => {
    if (invoiceDetails?.length > 0) {
    }
  }, [invoiceDetails]);

  useEffect(() => {
    dispatch(setActiveForm(""));
  }, [dispatch]);

  // Fetch store quick orders on mount and on notification
  useEffect(() => {
    dispatch(fetchStoreQuickOrders());
  }, [dispatch, notificationPopup]);

  useEffect(() => {
    dispatch(setLoading(true));
    const debouncedFetchOrders = debounce((page, limit, payload, id) => {
      dispatch(fetchOrdersOfStore({ page, limit, payload, id }));
    }, 300);

    const payload = getPayload(selected, filterByStatus);
    const id = storeDetail?.store?.SID;

    if (id) {
      if (currentPage >= 1 || !data?.orders?.length) {
        debouncedFetchOrders(currentPage, limit, payload, id);
      }

      return () => {
        debouncedFetchOrders.cancel();
      };
    } else {
      const delay = setTimeout(() => {
        if (currentPage >= 1 || !data?.orders?.length) {
          debouncedFetchOrders(currentPage, limit, payload, id);
        }
      }, 300);

      return () => {
        clearTimeout(delay);
        debouncedFetchOrders.cancel();
      };
    }
  }, [
    dispatch,
    currentPage,
    limit,
    selected,
    filterByStatus,
    storeDetail?.store?.SID,
    notificationPopup,
    data?.orders?.length
  ]);


  useEffect(() => {
    const initialStates = {};

    filteredData?.orders?.forEach((order) => {
      const isViewInvoice =
        order?.isAccepted === true || order?.isCancelled === true;

      const isViewProducts =
        order?.isPacked === true && order?.isCancelled === false
          ? false
          : order?.isAccepted === false ||
            (order?.isAccepted === true && order?.isPacked === false)
            ? true
            : order?.isCancelled === true
              ? true
              : false;

      const checkOrder = order?.isPacked === true;
      const isViewLabel =
        order?.isAccepted === true &&
        !order?.isCancelled &&
        !(order?.isDelivered === true || order?.isCollected === true);

      initialStates[order?.OID] = {
        isViewInvoice,
        isViewProducts,
        checkOrder,
        isViewLabel,
      };
    });

    setOrderViewStates(initialStates);
  }, [filteredData]);

  useEffect(() => {
    if (data?.orders) {
      setFilteredData(data);
    }
  }, [data]);

  useEffect(() => {
    if (data?.orders?.length > 0) {
      const updatedProducts = data?.orders
        ?.map((order) =>
          order?.orderProducts?.map((product) => ({
            typeIndex: product?.typeIndex || "",
            morningTime: product?.morningTime || 0,
            midDay: product?.midDay || 0,
            eveningTime: product?.eveningTime || 0,
            night: product?.night || 0,
            takenTime: product?.takenTime || "A/F",
            takenTimeIndex: product?.takenTimeIndex || "",
            extra: product?.extra || 0,
            extraIndex: product?.extraIndex || 0,
          }))
        )
        .flat();
      setInitialFormValues({
        products: updatedProducts,
      });
    }
  }, [data]);
  const totalPages = data?.totalPages || 1;
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleInvoiceChange = (orderId, field, value) => {
    setInvoiceData((prev) => ({
      ...prev,
      [orderId]: {
        ...prev[orderId],
        [field]: value,
      },
    }));
  };

  const updateInvoiceOnBackend = async (order, updatedFields) => {
    const orderId = order?.OID;
    
    const currentInvoiceNo = updatedFields.invoiceNo !== undefined 
      ? updatedFields.invoiceNo 
      : (invoiceData[orderId]?.invoiceNo !== undefined 
         ? invoiceData[orderId]?.invoiceNo 
         : order?.invoice?.invoiceNo || "");
         
    const currentInvoiceAmount = updatedFields.invoiceAmount !== undefined 
      ? updatedFields.invoiceAmount 
      : (invoiceData[orderId]?.invoiceAmount !== undefined 
         ? invoiceData[orderId]?.invoiceAmount 
         : order?.invoice?.invoiceAmount || "");
         
    const currentPaymentType = updatedFields.paymentType !== undefined 
      ? updatedFields.paymentType 
      : (selectedPayment.find((item) => item.OID === orderId)?.payment || order?.payment || "");

    try {
      await dispatch(
        updateOrderInvoice({
          orderId,
          invoiceData: {
            invoiceNo: currentInvoiceNo,
            invoiceAmount: currentInvoiceAmount,
            paymentType: currentPaymentType,
          },
        })
      ).unwrap();
      
      setFilteredData((prevState) => {
        return {
          ...prevState,
          orders: prevState?.orders?.map((item) => {
            if (item?.OID === orderId) {
              return {
                ...item,
                invoice: {
                  ...item.invoice,
                  invoiceNo: currentInvoiceNo,
                  invoiceAmount: currentInvoiceAmount,
                  paymentType: currentPaymentType,
                },
                payment: currentPaymentType,
              };
            }
            return item;
          }),
        };
      });
    } catch (error) {
      console.error("Failed to update invoice details:", error);
    }
  };

  const handleInvoiceFieldBlurOrEnter = (order, field, value) => {
    updateInvoiceOnBackend(order, { [field]: value });
  };

  const handleInvoiceKeyDown = (e, order, field, value) => {
    if (e.key === "Enter") {
      e.target.blur();
    }
  };
  useEffect(() => {
    const handleKeyPress = (event) => {
      switch (event.key) {
        case "F1":
          event.preventDefault();
          setSelected("all");
          break;
        case "F2":
          event.preventDefault();
          setSelected("clinic");
          break;
        case "F3":
          event.preventDefault();
          setSelected("collect");
          break;
        case "F4":
          event.preventDefault();
          setSelected("address");
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [dispatch]);
  const handleButtonClick = (value) => {
    setSelected(value);
  };
  const handleFilterByClick = (value) => {
    setFilterByStatus(value);
  };
  useEffect(() => {
    filteredData?.orders?.forEach((order) => {
      const orderExists = selectedPayment.find(
        (item) => item.OID === order.OID
      );
      if (!orderExists && order?.OID) {
        setSelectedPayment((prev) => [
          ...prev,
          { OID: order.OID, payment: order?.payment || "" },
        ]);
      }
    });
  }, [filteredData, selectedPayment]);

  const handleChangeStatus = async (orderId, newStatus, order) => {
    let statusKey = "";

    switch (newStatus) {
      case "Accepted":
        statusKey = { isAccepted: true };
        break;
      case "Packed":
        const currentInvoiceData = invoiceData[orderId] || {};
        currentInvoiceData.paymentType = selectedPayment.find(
          (item) => item.OID === orderId
        )?.payment;
        if (!currentInvoiceData?.invoiceNo) {
          toast.error("Please enter invoice number!");
        } else if (!currentInvoiceData?.invoiceAmount) {
          toast.error("Please enter invoice amount!");
        } else if (!currentInvoiceData?.paymentType) {
          toast.error("Please select a payment method!");
        } else {
          statusKey = { isPacked: true, invoice: currentInvoiceData };
        }
        setOrderViewStates((prev) => ({
          ...prev,
          [orderId]: {
            ...prev[orderId],
            isViewProducts: true,
            isViewInvoice: true,
            isViewLabel: true,
          },
        }));
        break;
      case "collected":
        const currentInvoiceDataOfCollect = invoiceData[orderId] || {};
        currentInvoiceDataOfCollect.paymentType = selectedPayment.find(
          (item) => item.OID === orderId
        )?.payment;
        currentInvoiceDataOfCollect.IVID =
          order?.invoice?.IVID || invoiceData[orderId]?.IVID;
        statusKey = {
          isCollected: true,
          invoice: currentInvoiceDataOfCollect,
        };

        break;
      case "Dispatched":
        const currentInvoiceDataOfDispatch = invoiceData[orderId] || {};
        currentInvoiceDataOfDispatch.paymentType = selectedPayment.find(
          (item) => item.OID === orderId
        )?.payment;
        currentInvoiceDataOfDispatch.IVID =
          order?.invoice?.IVID || invoiceData[orderId]?.IVID;
        statusKey = {
          isDispatched: true,
          invoice: currentInvoiceDataOfDispatch,
        };
        setOrderViewStates((prev) => ({
          ...prev,
          [orderId]: {
            ...prev[orderId],
            isViewLabel: true,
            isViewInvoice: true
          },
        }));
        break;
      case "Delivered":
        const currentInvoiceDataOfDeliver = invoiceData[orderId] || {};
        currentInvoiceDataOfDeliver.paymentType = selectedPayment.find(
          (item) => item.OID === orderId
        )?.payment;

        currentInvoiceDataOfDeliver.IVID = order?.invoice?.IVID || invoiceData[orderId]?.IVID;
        statusKey = {
          isDelivered: true,
          invoice: currentInvoiceDataOfDeliver,
        };
        break;
      default:
        break;
    }

    try {
      if (statusKey) {
        const response = await dispatch(
          updateOrderStatus({ orderId, statusKey, invoiceData: invoiceData[orderId] || {} })
        ).unwrap();

        // Check if response contains error message
        if (response?.status === 200) {
          setFilteredData((prevState) => {
            return {
              ...prevState,
              orders: prevState?.orders?.map((order) => {
                if (order?.OID === orderId) {
                  return {
                    ...order,
                    ...statusKey,
                    orderStatus: newStatus,
                  };
                }
                return order;
              }),
            };
          });

          handleInvoiceChange(
            order?.OID,
            "IVID",
            response?.data?.invoiceData?.IVID
          );
          // Now update order view states based on newStatus
          if (newStatus === "Accepted") {
            setOrderViewStates((prev) => ({
              ...prev,
              [orderId]: {
                ...prev[orderId],
                isViewInvoice: true,
                isViewLabel: true,
              },
            }));
          }
          const queryPayload = getPayload(selected, filterByStatus);
          const id = storeDetail?.store?.SID;
          if (id) {
            dispatch(
              fetchOrdersOfStore({
                page: currentPage,
                limit,
                payload: queryPayload,
                id,
              })
            );
          }
        } else {
          console.error(
            "An error occurred:",
            response?.message || "Unknown error"
          );
          if (response?.response?.data?.message) {
            toast.error(response?.response?.data?.message);
          } else {
            toast.error(response?.message);
          }
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const handleViewImage = (order) => {
    if (order?.filePath?.length > 0) {
      window.open(order?.filePath);
    } else if (order?.pdfPath?.length > 0) {
      window.open(order?.pdfPath);
    } else if (order?.qoUploadUrl?.length > 0) {
      window.open(order?.qoUploadUrl);
    }
  };
  const handleEditOrder = (order) => {
    dispatch(setOrderById(order));
    dispatch(setActiveForm("Edit"));
    if (onToggleEditor) onToggleEditor();
  };

  const handlePaymentChange = (e, order) => {
    const value = e.target.value;
    const orderId = order?.OID;

    // Update the selected payment for the specific order by finding the order ID
    setSelectedPayment((prev) =>
      prev.map((item) =>
        item.OID === orderId ? { ...item, payment: value } : item
      )
    );

    // Removed erroneous invoiceAmount update with payment value
  };
  const copyToClipboard = (text, label) => {
    if (!text || text === "N/A" || text === "Unknown Patient") return;
    navigator.clipboard.writeText(text).then(() => {
      toast.success(`${label} copied!`, {
        icon: '📋',
        style: {
          borderRadius: '10px',
          background: '#333',
          color: '#fff',
        },
      });
    });
  };

  const formatTime = (timeString) => {
    const date = new Date(timeString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const finalHandleConfirmCancel = async () => {
    const OID = orderToCancel?.OID;
    const reason = cancelReason;

    if (!reason.trim()) {
      toast.error("Please provide a reason for cancellation");
      return;
    }

    try {
      const cancelledReason = { cancelReason: reason };
      const response = await dispatch(cancelOrder({ OID, cancelledReason })).unwrap();

      if (response.status) {
        setFilteredData((prevData) => {
          const updatedOrders = prevData?.orders?.map((order) =>
            order.OID === OID ? { ...order, isCancelled: true, cancelReason: reason } : order
          );
          return { ...prevData, orders: updatedOrders };
        });
        setOrderToCancel(null);
        setCancelReason("");
        const queryPayload = getPayload(selected, filterByStatus);
        const id = storeDetail?.store?.SID;
        if (id) {
          dispatch(fetchOrdersOfStore({ page: currentPage, limit, payload: queryPayload, id }));
        }
        toast.success("Order cancelled successfully");
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
      toast.error("Failed to cancel order");
    }
  };

  const handleMarkAsPaid = (orderId) => {
    setConfirmModalState({ isOpen: true, orderId });
  };

  const executeMarkAsPaid = async () => {
    const orderId = confirmModalState.orderId;
    setConfirmModalState({ isOpen: false, orderId: null });

    try {
      const res = await apiAxios.patch(`/api/order/mark-paid/${orderId}`);
      if (res.status === 200) {
        toast.success("Order marked as paid successfully!");
        setFilteredData((prevState) => {
          return {
            ...prevState,
            orders: prevState?.orders?.map((order) => {
              if (order?.OID === orderId) {
                return { ...order, isPaid: true };
              }
              return order;
            }),
          };
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to mark order as paid.");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "Asia/Kolkata"
    });
  };



  const generateLabelHTML = (order) => {
    if (!order) {
      console.error("Order data is required to generate a label.");
      return "";
    }

    const labels = order.orderProducts.flatMap((product) => {
      const productLabels = [];
      const productType = extentions[product?.type]?.extention
      for (let i = 0; i < product.orderQty; i++) {
        productLabels.push(`
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Label Print</title>
        <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;600&display=swap" rel="stylesheet">

       <style>
        body {
            margin: 0;
            padding: 0;          
            font-family: "Roboto";
        }
        @media print {
            body {
                margin: 0;

                padding: 0;
            }
        }
    </style>
      </head>
      <body>
  <div style="width: 36mm; height: 15mm;">
        <table style=" width: 100%;padding: 0;border:none;margin-bottom:20px" cellpadding="0" cellspacing="0">
            <tbody>
                <tr style="padding: 0;margin: 0;">
                    <td style="padding: 0;margin: 0;">
                        <table style="width: 100%;height:100%;padding: 0;margin: 0;border:none;" cellpadding="0"
                            cellspacing="0">
                            <tbody>
                                <tr style="padding: 0;margin: 0;">
                                  <td style="padding: 0;margin: 0;width:60%">
                                    <h1 style="font-size: 9px;font-weight:900; margin: 0; padding:0  ">
                                      * Hyperapt *
                                    </h1>
                                    <h3 style="font-size: 7.5px;margin: 0;padding:0  ;white-space: nowrap; 
                                     overflow: hidden;text-overflow: ellipsis;width: 18mm">
                                      ${(order?.patientDetail?.name || order?.PatientDetail?.name || order?.patientDetails?.name || "").toUpperCase()}  ${(order?.patientDetail?.surname || order?.PatientDetail?.surname || order?.patientDetails?.surname || "").toUpperCase()}
                                    </h3>
                                    <h3 style="font-size:7.5px;margin: 0; padding: 0 0 1px;white-space: nowrap; 
                                     overflow: hidden;text-overflow: ellipsis;width: 18mm">
                                      ORDER ID: ${order?.OID}
                                    </h3>
                                  </td>
                                  <td style="padding: 0;margin: 0;width: 40%;padding-left: 1px;border-left: solid #000;border-width:thin">
                                    <h1 style="font-size: 7.5px;margin: 0;padding:0  ;white-space: nowrap; 
                                      overflow: hidden;text-overflow: ellipsis;width: 18mm">
                                      ${(product?.productName || "").toUpperCase()}
                                    </h1>
                                    <h3 style="font-size: 7.3px;margin: 0;padding:0  ">${product?.takenTime === "A/F"
            ? "TAKE AFTER FOOD"
            : product?.takenTime === "B/F"
              ? "TAKE BEFORE FOOD"
              : ""
          }</h3>
                                    <h3 style="font-size: 7.3px;margin: 0;padding:0  ">
                                     FOR ${product?.rxDays} DAYS
                                    </h3>
                                  </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr style="padding: 0;margin: 0;">
                    <td style="padding: 0px 0 0;margin: 0;border:0.2px solid #000;width:30mm">
                        <table style="width: 100%;padding: 0;margin: 0;border:none;" cellpadding="0" cellspacing="0">
                            <tbody>
                                <tr style="padding: 0;margin: 0;">
                                    <td style="padding: 0;margin: 0;text-align: center;border-bottom: 0.2px solid #000;">
                                        <h3 style="font-size:9.8px;margin: 0; padding: 0;">8 AM</h3>
                                    </td>
                                    <td style="padding: 0;margin: 0;text-align: center;border-bottom: 0.2px solid #000;">
                                        <h3 style="font-size:9.8px;margin: 0;padding: 0;">1 PM</h3>
                                    </td>
                                    <td style="padding: 0;margin: 0;text-align: center;border-bottom: 0.2px solid #000;">
                                        <h3 style="font-size:9.8px;margin: 0;padding: 0;">7 PM</h3>
                                    </td>
                                    <td style="padding: 0;margin: 0;text-align: center;border-bottom: 0.2px solid #000;">
                                        <h3 style="font-size:9.8px;margin: 0;padding: 0;">10 PM</h3>
                                    </td>
                                </tr>
                                <tr style="padding: 0;margin: 0;">
                                    <td style="padding: 0;margin: 0;text-align: center;">
                                        <h3 style="font-size:9.8px;margin: 0;padding: 0;">${Number(product?.morningTime) !== 0
            ? product?.morningTime + productType
            : ""
          }</h3>
                                    </td>
                                    <td style="padding: 0;margin: 0;text-align: center;">
                                        <h3 style="font-size:9.8px;margin: 0;padding: 0;">${Number(product?.midDay) !== 0
            ? product?.midDay + productType
            : ""
          }</h3>
                                    </td>
                                    <td style="padding: 0;margin: 0;text-align: center;">
                                        <h3 style="font-size:9.8px;margin: 0;padding: 0;">${Number(product?.eveningTime) !== 0
            ? product?.eveningTime + productType
            : ""
          }</h3>
                                    </td>
                                    <td style="padding: 0;margin: 0;text-align: center;">
                                        <h3 style="font-size:9.8px;margin: 0;padding: 0;">${Number(product?.night) !== 0
            ? product?.night + productType
            : ""
          }</h3>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
      </body>
      </html>
   `);
      }
      return productLabels;
    });

    return labels.join("");
  };

  const handleCreateLable = (order) => {
    const labelContent = generateLabelHTML(order);
    if (!labelContent) return;

    const printIframe = document.createElement("iframe");
    printIframe.style.position = "absolute";
    printIframe.style.top = "-1000px"; // Hide the iframe
    document.body.appendChild(printIframe);

    const printDocument =
      printIframe.contentWindow || printIframe.contentDocument;
    if (printDocument.document) {
      printDocument.document.open();
      printDocument.document.write(labelContent);
      printDocument.document.close();

      // Trigger print dialog
      setTimeout(() => {
        printDocument.print();
        document.body.removeChild(printIframe); // Clean up
      }, 500);
    }
  };

  return (
    <section>
      {loading ? <Loader loading={loading} /> : null}
      <div className="flex items-center justify-between gap-2 bg-white p-1.5 pr-3 rounded-[16px] shadow-sm border border-primary-100 mb-4 sticky top-0 z-[100] backdrop-blur-md bg-white/90">
        {/* Unified Control Center: Menu | Filter Logic Swapper | Editor */}
        <div className="flex items-center gap-2 overflow-hidden flex-grow">
          {/* Menu Toggle */}
          <div className="flex items-center shrink-0">
            <StoreSidebarToggle className="!p-2 bg-primary-50 hover:bg-primary-100 text-primary-700 rounded-xl transition-all active:scale-95" />
          </div>

          <div className="h-8 w-px bg-gray-100 mx-0.5 hidden sm:block"></div>

          {/* Dynamic Filter Strip: Compact & Scrollable */}
          <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide p-1 bg-gray-50/50 rounded-[12px] border border-primary-100/50">
            {!showStateFilters ? (
              <>
                {/* Mode 1: Delivery Type Filters */}
                <div className="flex gap-1 shrink-0">
                  {updatedOrderFilterButtons?.map((btn) => (
                    <button
                      key={btn.value}
                      onClick={() => handleButtonClick(btn.value)}
                      className={`flex items-center gap-2 px-3 py-1.5 rounded-[8px] text-[12px] font-bold transition-all duration-300 whitespace-nowrap ${selected === btn.value
                        ? "bg-primary-600 text-white scale-[1.02]"
                        : "text-gray-500 hover:bg-white hover:text-primary-600"
                        }`}
                    >
                      {btn.label.split(" (")[0]}
                      <span className={`px-1.5 py-0.5 rounded-full text-[10px] ${selected === btn.value ? "bg-white/20 text-white" : "bg-gray-200 text-gray-600"}`}>
                        {btn.count}
                      </span>
                    </button>
                  ))}
                </div>

                <div className="h-6 w-px bg-gray-200 mx-1 shrink-0"></div>

                {/* Swapper Trigger */}
                <button
                  onClick={() => setShowStateFilters(true)}
                  className="flex items-center gap-2 px-3 py-1.5 rounded-[8px] text-[12px] font-bold bg-indigo-50 text-indigo-700 hover:bg-indigo-600 hover:text-white transition-all duration-300 border border-indigo-200 whitespace-nowrap shadow-sm group shrink-0"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="group-hover:rotate-180 transition-transform duration-500"><path d="M4 21v-7" /><path d="M4 10V3" /><path d="M12 21v-9" /><path d="M12 8V3" /><path d="M20 21v-5" /><path d="M20 12V3" /><line x1="1" y1="14" x2="7" y2="14" /><line x1="9" y1="8" x2="15" y2="8" /><line x1="17" y1="16" x2="23" y2="16" /></svg>
                  Filter by State ({updatedOrderStatusButtons?.find(b => b.value === filterByStatus)?.label || 'All'})
                </button>
              </>
            ) : (
              <>
                {/* Mode 2: Order State Filters */}
                <button
                  onClick={() => setShowStateFilters(false)}
                  className="flex items-center justify-center w-8 h-8 rounded-full bg-white border border-gray-200 text-gray-400 hover:text-primary-600 hover:border-primary-200 transition-all shrink-0 shadow-sm"
                  title="Back to Delivery Types"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" /></svg>
                </button>

                <div className="flex gap-1 overflow-x-auto scrollbar-hide shrink-0">
                  {updatedOrderStatusButtons?.map((btn) => (
                    <button
                      key={btn.value}
                      onClick={() => handleFilterByClick(btn.value)}
                      className={`flex items-center gap-2 px-3 py-1.5 rounded-[8px] text-[12px] font-bold transition-all duration-300 whitespace-nowrap ${filterByStatus === btn.value
                        ? "bg-indigo-600 text-white shadow-md shadow-indigo-100 scale-[1.02]"
                        : "text-gray-500 hover:bg-white hover:text-indigo-600"
                        }`}
                    >
                      {btn.label}
                      <span className={`px-1.5 py-0.5 rounded-full text-[10px] ${filterByStatus === btn.value ? "bg-white/20 text-white" : "bg-gray-200 text-gray-600"}`}>
                        {btn.count}
                      </span>
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Action: Editor Toggle */}
        <div className="flex items-center shrink-0 ml-1">
          <button
            onClick={onToggleEditor}
            className="flex items-center gap-2 px-8 py-2 bg-primary-50 text-primary-600 rounded-[10px] font-black text-[11px] uppercase tracking-widest hover:border-primary-700 hover:scale-[1.02] active:scale-95 transition-all whitespace-nowrap border border-primary-100"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
            Editor
          </button>
        </div>
      </div>
      <div>
        <Formik
          initialValues={initialFormValues}
          validationSchema={createOrderValidation}
        // onSubmit={handleSubmit}
        >
          {({ values, handleChange, setFieldValue }) => (
            <Form className="dashboard-container">
              {/* <div className="grid grid-cols-12 gap-[8px] mb-3"> */}
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-4 gap-y-1 mb-3">

                {/* Quick Order Tiles */}
                {storeQuickOrders?.length > 0 && (
                  <div className="col-span-1 lg:col-span-12 mb-4">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
                      <h3 className="text-[12px] font-bold text-orange-600 uppercase tracking-wider">Quick Orders</h3>
                      <span className="text-[10px] font-bold bg-orange-100 text-orange-600 px-2 py-0.5 rounded-full">{storeQuickOrders.length}</span>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-3">
                      {storeQuickOrders.map((qo) => (
                        <div
                          key={qo.QID}
                          className="col-span-1 lg:col-span-6 border border-orange-200 rounded-[16px] p-4 bg-gradient-to-br from-orange-50/60 to-amber-50/30 hover:shadow-md hover:ring-1 hover:ring-orange-300 transition-all"
                        >
                          {/* QO Header */}
                          <div className="flex items-center justify-between mb-3">
                            <div className="flex items-center gap-2">
                              <span className="text-[16px] font-extrabold text-orange-700">{qo.QID}</span>
                              <span className="text-[9px] px-2 py-0.5 rounded-full font-bold uppercase tracking-widest bg-orange-100 text-orange-600 border border-orange-200">
                                Quick Order
                              </span>
                            </div>
                            <span className="text-[10px] text-gray-400 font-medium">
                              {new Date(qo.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'Asia/Kolkata' })}
                            </span>
                          </div>

                          {/* Patient & Doctor Info */}
                          <div className="grid grid-cols-2 gap-3 mb-3">
                            <div className="bg-white rounded-xl p-2.5 border border-gray-100">
                              <p className="text-[9px] uppercase tracking-wider font-bold text-gray-400 mb-1">Patient</p>
                              <p className="text-[12px] font-semibold text-gray-800 leading-tight">
                                {qo.patientDetail?.name || ''} {qo.patientDetail?.surname || ''}
                              </p>
                              <p className="text-[10px] text-gray-500 mt-0.5">
                                {qo.patientDetail?.phoneNumber || ''}
                                {qo.patientDetail?.gender ? ` • ${qo.patientDetail.gender}` : ''}
                                {qo.patientDetail?.age ? ` • ${qo.patientDetail.age} yrs` : ''}
                              </p>
                            </div>
                            <div className="bg-white rounded-xl p-2.5 border border-gray-100">
                              <p className="text-[9px] uppercase tracking-wider font-bold text-gray-400 mb-1">Doctor</p>
                              <p className="text-[12px] font-semibold text-gray-800 leading-tight">
                                Dr. {qo.doctor?.name || ''} {qo.doctor?.surname || ''}
                              </p>
                              <p className="text-[10px] text-gray-500 mt-0.5">{qo.DID}</p>
                            </div>
                          </div>

                          {/* Payment & Delivery Methods Info */}
                          <div className="flex items-center gap-3 mb-3 text-[10px] uppercase font-bold tracking-wider">
                            <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded border border-blue-100/50">
                              Payment: {qo.paymentMethod === 'upi' ? 'UPI' : qo.paymentMethod === 'cash' ? 'Cash' : qo.paymentMethod === 'card' ? 'Card' : qo.paymentMethod || 'UPI'}
                            </span>
                            <span className="bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded border border-emerald-100/50">
                              Delivery: {qo.deliveryMethod === 'isClinic' ? 'Clinic' : qo.deliveryMethod === 'isCollect' ? 'Collect' : qo.deliveryMethod === 'isAddress' ? 'Address' : qo.deliveryMethod || 'Clinic'}
                            </span>
                          </div>

                          {/* Optional Order Notes */}
                          {qo.qoNotes && (
                            <div className="mb-3 p-2.5 bg-white rounded-xl border border-orange-100 text-[11px] text-gray-700 shadow-sm">
                              <span className="font-bold text-orange-600 block uppercase tracking-wider text-[9px] mb-0.5">Order Notes:</span>
                              <p className="whitespace-pre-line leading-relaxed">{qo.qoNotes}</p>
                            </div>
                          )}

                          {/* Action Buttons */}
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => window.open(qo.qoUploadUrl, '_blank')}
                              className="flex-1 py-2 rounded-xl text-[11px] font-bold bg-blue-50 text-blue-600 hover:bg-blue-100 border border-blue-200 transition-colors text-center"
                            >
                              Open Upload
                            </button>
                            <button
                              onClick={() => {
                                dispatch(setActiveQuickOrder(qo));
                                dispatch(setOrderById({}));
                                dispatch(setActiveForm(''));
                                if (onToggleEditor) onToggleEditor();
                              }}
                              className="flex-1 py-2 rounded-xl text-[11px] font-bold bg-green-50 text-green-600 hover:bg-green-100 border border-green-200 transition-colors text-center"
                            >
                              Create Order
                            </button>
                            <button
                              onClick={() => setQoCancelTarget(qo.QID)}
                              className="py-2 px-3 rounded-xl text-[11px] font-bold bg-red-50 text-red-600 hover:bg-red-100 border border-red-200 transition-colors"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Quick Order Cancel Modal (Store) */}
                {qoCancelTarget && (
                  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 p-5">
                      <h3 className="text-lg font-bold text-gray-900 mb-2">Cancel Quick Order</h3>
                      <p className="text-sm text-gray-500 mb-3">QID: <strong>{qoCancelTarget}</strong></p>
                      <textarea
                        value={qoCancelReason}
                        onChange={(e) => setQoCancelReason(e.target.value)}
                        placeholder="Reason for cancellation..."
                        className="w-full border border-gray-200 rounded-xl p-3 text-sm focus:outline-none focus:border-red-400 focus:ring-1 focus:ring-red-100 resize-none"
                        rows={3}
                      />
                      <div className="flex items-center gap-2 mt-4">
                        <button
                          onClick={() => { setQoCancelTarget(null); setQoCancelReason(''); }}
                          className="flex-1 py-2 rounded-xl text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors"
                        >
                          Go Back
                        </button>
                        <button
                          onClick={async () => {
                            if (!qoCancelReason.trim()) {
                              toast.error('Please provide a reason');
                              return;
                            }
                            await dispatch(cancelQuickOrder({ qid: qoCancelTarget, cancelReason: qoCancelReason }));
                            setQoCancelTarget(null);
                            setQoCancelReason('');
                          }}
                          className="flex-1 py-2 rounded-xl text-sm font-bold text-white bg-red-500 hover:bg-red-600 transition-colors"
                        >
                          Cancel Quick Order
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {filteredData?.orders?.length > 0 ? (
                  filteredData?.orders?.map((order, index) => {
                    const states = orderViewStates[order.OID] || {
                      isViewInvoice: false,
                      isViewProducts: true,
                      isViewLabel: false,
                    };

                    const invoiceLength =
                      order?.invoice !== null ? Object.keys(order?.invoice) : 0;
                    const filterdInvData = invoiceDetails?.find(
                      (item) => item?.orderId === order.OID
                    );

                    const orderType = order?.isClinic
                      ? "clinic"
                      : order?.isCollect
                        ? "collect"
                        : order?.isAddress
                          ? "address"
                          : "";
                    return (
                      <div className="col-span-1 lg:col-span-6" key={index}>
                        <div className={`mb-3 break-inside-avoid border-l-[5px] border rounded-[20px] bg-white shadow-sm hover:shadow-md hover:ring-1 hover:ring-primary-400 transition-all duration-300 ${!order?.isCancelled
                          ? (order?.isAccepted && order?.isPacked && order?.isDispatched && order?.isDelivered) || order?.isCollected
                            ? "border-success-500/30 border-l-success-500"
                            : order?.isAccepted && order?.isPacked && order?.isDispatched
                              ? "border-indigo-500/30 border-l-indigo-500"
                              : order?.isAccepted && order?.isPacked
                                ? "border-teal-500/30 border-l-teal-500"
                                : order?.isAccepted
                                  ? "border-yellow-400/30 border-l-yellow-400"
                                  : "border-primary-300/30 border-l-primary-300"
                          : "border-danger-500/30 border-l-danger-500"
                          }`}>
                          <div className="p-3">
                            <div className="relative mb-2 pb-2 border-b border-gray-100">
                              {/* Top row: Status, ID, Type and Timings */}
                              <div className="flex flex-wrap lg:flex-nowrap items-center justify-between gap-2 mb-2">
                                <div className="flex items-center gap-2 flex-wrap min-w-0">
                                  <h2
                                    className="text-[18px] lg:text-[20px] font-bold text-gray-900 leading-none truncate cursor-pointer hover:text-primary-600 transition-all active:scale-95"
                                    onClick={() => copyToClipboard(order?.OID, "Order ID")}
                                    title="Click to copy Order ID"
                                  >
                                    {order?.OID || "Order ID"}
                                  </h2>
                                  <span className={`flex items-center gap-1.5 text-[9px] px-2 py-0.5 rounded-full font-bold uppercase tracking-tight shrink-0 border ${order?.source === 'quick' ? 'bg-orange-100 text-orange-700 border-orange-200' :
                                    order?.source === 'scan' ? 'bg-purple-100 text-purple-700 border-purple-200' :
                                    order?.source === 'store' ? 'bg-blue-100 text-blue-700 border-blue-200' :
                                    order?.source === 'reorder' ? 'bg-teal-100 text-teal-700 border-teal-200' :
                                    'bg-gray-100 text-gray-700 border-gray-200'
                                  }`}>
                                    {order?.source || 'standard'}
                                  </span>
                                  <span className={`flex items-center gap-1.5 text-[9px] px-2 py-0.5 rounded-full font-bold uppercase tracking-tight shrink-0 border ${orderType === 'clinic' ? 'bg-white text-gray-500 border-gray-200' :
                                    orderType === 'collect' ? 'bg-orange-50 text-orange-600 border-orange-100' :
                                      'bg-black text-white border-black'
                                    }`}>
                                    {/* Integrated Status Bullet */}
                                    <div className={`w-2 h-2 rounded-full shrink-0 ${!order?.isCancelled
                                      ? (order?.isAccepted && order?.isPacked && order?.isDispatched && order?.isDelivered) || order?.isCollected
                                        ? "bg-success-500"
                                        : order?.isAccepted && order?.isPacked && order?.isDispatched
                                          ? "bg-indigo-500"
                                          : order?.isAccepted && order?.isPacked && orderType !== "collect"
                                            ? "bg-teal-500"
                                            : order?.isAccepted
                                              ? "bg-yellow-400"
                                              : "bg-primary-300"
                                      : "bg-danger-500"
                                      }`}></div>
                                    {orderType}
                                  </span>
                                </div>

                                {/* Timing Strip - Optimized for narrow columns */}
                                <div className="flex items-center gap-3 bg-gray-50 px-3 py-1 rounded-full border border-gray-100 shrink-0">
                                  <div className="flex items-center gap-3">
                                    {/* Dynamic Timing Strip: Only shows available timestamps */}
                                    <span className="text-[11px] font-bold text-gray-600">
                                      {formatTime(order?.createdAt)}
                                    </span>

                                    {(order?.isCollect ? order?.packedTime?.length > 0 : order?.dispatchTime?.length > 0) && (
                                      <>
                                        <div className="w-1 h-1 rounded-full bg-gray-300"></div>
                                        <span className="text-[11px] font-bold text-indigo-600">
                                          {order?.isCollect ? formatTime(order?.packedTime) : formatTime(order?.dispatchTime)}
                                        </span>
                                      </>
                                    )}

                                    {(order?.isCollect ? order?.collectedTime?.length > 0 : order?.deliveredTime?.length > 0) && (
                                      <>
                                        <div className="w-1 h-1 rounded-full bg-gray-300"></div>
                                        <span className="text-[11px] font-bold text-success-600">
                                          {order?.isCollect ? formatTime(order?.collectedTime) : formatTime(order?.deliveredTime)}
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Precise 3-Column Layout */}
                              <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3">
                                <div className="flex-grow grid grid-cols-1 sm:grid-cols-3 gap-x-3 gap-y-2">
                                  {/* Column 1: Patient Information */}
                                  <div className="flex flex-col">
                                    <span className="text-[10px] font-regular text-gray-400 uppercase tracking-wider mb-1">Patient</span>
                                    <p
                                      className="text-[14px] font-bold text-gray-900 leading-tight cursor-pointer hover:text-primary-600 transition-all active:scale-95"
                                      onClick={() => copyToClipboard(
                                        (order?.patientDetail?.name || "") + " " + (order?.patientDetail?.surname || ""),
                                        "Patient Name"
                                      )}
                                      title="Click to copy Patient Name"
                                    >
                                      {(order?.patientDetail?.name || order?.patientDetail?.surname) || (order?.PatientDetail?.name || order?.PatientDetail?.surname) || (order?.patientDetails?.name || order?.patientDetails?.surname)
                                        ? `${order?.patientDetail?.name || order?.PatientDetail?.name || order?.patientDetails?.name || ""} ${order?.patientDetail?.surname || order?.PatientDetail?.surname || order?.patientDetails?.surname || ""}`
                                        : "Unknown Patient"}
                                    </p>
                                    <div
                                      className="flex items-center gap-1.5 mt-1.5 text-gray-500 cursor-pointer hover:text-primary-600 transition-all active:scale-95"
                                      onClick={() => copyToClipboard(order?.patientDetail?.phoneNumber, "Phone Number")}
                                      title="Click to copy Contact"
                                    >
                                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
                                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                      </svg>
                                      <span className="text-[12px] font-semibold tracking-tight">{order?.patientDetail?.phoneNumber || order?.PatientDetail?.phoneNumber || order?.patientDetails?.phoneNumber || "No Contact"}</span>
                                    </div>
                                    <div
                                      className="flex items-start gap-1.5 mt-1.5 text-gray-400 cursor-pointer hover:text-primary-600 transition-all active:scale-95"
                                      onClick={() => copyToClipboard(
                                        resolveLocationDetails(order?.pincode || order?.patientDetail?.pincode, order?.city || order?.patientDetail?.city) ||
                                        ([order?.city || order?.patientDetail?.city, order?.pincode || order?.patientDetail?.pincode].filter(Boolean).join(" - ")),
                                        "Location"
                                      )}
                                      title="Click to copy Pincode/City"
                                    >
                                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 mt-0.5">
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                        <circle cx="12" cy="10" r="3" />
                                      </svg>
                                      <span className="text-[12px] font-semibold tracking-tight leading-tight truncate max-w-[120px]" title={resolveLocationDetails(order?.pincode || order?.patientDetail?.pincode, order?.city || order?.patientDetail?.city)}>
                                        {resolveLocationDetails(order?.pincode || order?.patientDetail?.pincode, order?.city || order?.patientDetail?.city) ||
                                          ([order?.city || order?.patientDetail?.city, order?.pincode || order?.patientDetail?.pincode].filter(Boolean).join(" - ") || "No Location")}
                                      </span>
                                      {order?.isAddress && (
                                        <button
                                          type="button"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedAddressOrder(order);
                                          }}
                                          className="ml-1 text-[10px] font-bold text-indigo-700 bg-indigo-50 px-1.5 py-0.5 rounded border border-indigo-100 hover:bg-indigo-600 hover:text-white transition-all whitespace-nowrap"
                                        >
                                          SEE MAP
                                        </button>
                                      )}
                                    </div>
                                  </div>

                                  {/* Column 2: Doctor Information */}
                                  <div className="flex flex-col">
                                    <span className="text-[10px] font-regular text-gray-400 uppercase tracking-wider mb-1">Doctor</span>
                                    <p
                                      className="text-[14px] font-semibold text-gray-600 truncate leading-tight cursor-pointer hover:text-primary-600 transition-all active:scale-95"
                                      onClick={() => copyToClipboard(
                                        (order?.doctor?.personalInfo?.name || "") + " " + (order?.doctor?.personalInfo?.surname || ""),
                                        "Doctor Name"
                                      )}
                                      title="Click to copy Doctor Name"
                                    >
                                      {order?.doctor?.personalInfo?.name || order?.doctor?.personalInfo?.surname
                                        ? `Dr. ${order?.doctor?.personalInfo?.name || ""} ${order?.doctor?.personalInfo?.surname || ""}`
                                        : "Direct Agent"}
                                    </p>
                                    <div
                                      className="flex items-center gap-1.5 mt-1.5 text-gray-500 cursor-pointer hover:text-primary-600 transition-all active:scale-95"
                                      onClick={() => copyToClipboard(order?.XID, "XID")}
                                      title="Click to copy XID"
                                    >
                                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="shrink-0"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" /><polyline points="14 2 14 8 20 8" /><path d="M9 13h6" /><path d="M9 17h3" /></svg>
                                      <span className="text-[12px] font-semibold font-mono tracking-tight">{order?.XID || "N/A"}</span>
                                    </div>
                                    {order?.QID && (
                                      <div className="flex items-center gap-1.5 mt-1">
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
                                          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                                        </svg>
                                        <span className="text-[11px] font-bold text-orange-600">{order.QID}</span>
                                      </div>
                                    )}
                                  </div>

                                  {/* Column 3: Order Details */}
                                  <div className="flex flex-col">
                                    <span className="text-[10px] font-regular text-gray-400 uppercase tracking-wider mb-1">Details</span>
                                    <div className="flex items-center gap-1.5 leading-tight">
                                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400 shrink-0"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" /></svg>
                                      <span className="text-[14px] font-semibold text-gray-600">
                                        {order?.orderProducts?.reduce((total, product) => total + (Number(product?.orderQty) || 0), 0)} Units
                                      </span>
                                    </div>
                                    <div className="flex items-center gap-1.5 mt-1 text-gray-500">
                                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="shrink-0"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                                      <span className="text-[12px] font-semibold tracking-tight">{formatDate(order?.createdAt) || "-"}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Invoice & Payment Section - Only visible after Accept */}
                            {order?.isAccepted && (
                              <div className="grid grid-cols-12 gap-2 mt-2 animate-in fade-in slide-in-from-top-2 duration-300">
                                <div className={`col-span-4 px-3 py-2 rounded-lg border transition-all ${order?.isCancelled || order?.isDelivered || order?.isCollected ? "bg-gray-50 border-gray-100" : "bg-white border-gray-200"}`}>
                                  <span className="block text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-1">Invoice No.</span>
                                  <input
                                    type="text"
                                    placeholder="Enter No."
                                    className="w-full bg-transparent border-none outline-none text-[16px] font-bold text-primary-700 placeholder:text-gray-300"
                                    value={
                                      invoiceData[order?.OID]?.invoiceNo !== undefined
                                        ? invoiceData[order?.OID]?.invoiceNo
                                        : (invoiceLength?.length > 0
                                          ? order?.invoice?.invoiceNo
                                          : filterdInvData?.invoiceData?.invoiceNo) || ""
                                    }
                                    onChange={(e) => handleInvoiceChange(order?.OID, "invoiceNo", e.target.value)}
                                    onBlur={(e) => handleInvoiceFieldBlurOrEnter(order, "invoiceNo", e.target.value)}
                                    onKeyDown={(e) => handleInvoiceKeyDown(e, order, "invoiceNo", e.target.value)}
                                    disabled={order?.isCancelled || order?.isDelivered || order?.isCollected}
                                  />
                                </div>

                                <div className={`col-span-4 px-3 py-2 rounded-lg border transition-all ${order?.isCancelled || order?.isDelivered || order?.isCollected ? "bg-gray-50 border-gray-100" : "bg-white border-gray-200"}`}>
                                  <span className="block text-[11px] font-bold text-gray-400 uppercase tracking-wider mb-1">Invoice Amount</span>
                                  <div className="flex items-center gap-1">
                                    <span className="text-[16px] font-bold text-gray-400">₹</span>
                                    <input
                                      type="number"
                                      placeholder="0.00"
                                      className="w-full bg-transparent border-none outline-none text-[16px] font-bold text-primary-700 placeholder:text-gray-300"
                                      value={
                                        invoiceData[order?.OID]?.invoiceAmount !== undefined
                                          ? invoiceData[order?.OID]?.invoiceAmount
                                          : (invoiceLength?.length > 0
                                            ? order?.invoice?.invoiceAmount
                                            : filterdInvData?.invoiceData?.invoiceAmount) || ""
                                      }
                                      onChange={(e) => handleInvoiceChange(order?.OID, "invoiceAmount", e.target.value)}
                                      onBlur={(e) => handleInvoiceFieldBlurOrEnter(order, "invoiceAmount", e.target.value)}
                                      onKeyDown={(e) => handleInvoiceKeyDown(e, order, "invoiceAmount", e.target.value)}
                                      disabled={order?.isCancelled || order?.isDelivered || order?.isCollected}
                                    />
                                  </div>
                                </div>

                                {/* Payment Method - Custom Dropdown */}
                                <div className={`col-span-4 px-3 py-2 rounded-lg border transition-all relative payment-dropdown-container ${order?.isCancelled || order?.isDelivered || order?.isCollected ? "bg-gray-50 border-gray-100" : "bg-white border-gray-200"}`}>
                                  <span className="block text-[11px] mb-1 font-bold text-gray-400 uppercase tracking-wider">Payment Method</span>
                                  <div className="relative">
                                    <button
                                      type="button"
                                      disabled={order?.isDelivered || order?.isCollected || order?.isCancelled}
                                      onClick={() => setOpenDropdownId(openDropdownId === order.OID ? null : order.OID)}
                                      className={`w-full flex items-center justify-between text-[16px] font-bold uppercase transition-all ${order?.isDelivered || order?.isCollected || order?.isCancelled ? 'cursor-default text-gray-400' : 'cursor-pointer text-primary-700 hover:text-primary-800'}`}
                                    >
                                      <span>{selectedPayment.find((item) => item.OID === order.OID)?.payment || "Select"}</span>
                                      <div className={`transition-transform duration-300 text-gray-400 ${openDropdownId === order.OID ? "rotate-180 text-primary-500" : "hover:text-primary-400"}`}>
                                        <ArrowDown width="18" height="18" />
                                      </div>
                                    </button>

                                    {openDropdownId === order.OID && (
                                      <div className="absolute left-0 right-0 mt-4 bg-white border border-gray-100 rounded-lg shadow-2xl z-[70] overflow-hidden py-1 animate-in fade-in slide-in-from-top-1 duration-150">
                                        {["cash", "upi", "card"].map((method) => (
                                          <div
                                            key={method}
                                            onClick={() => {
                                              handlePaymentChange({ target: { value: method } }, order);
                                              setOpenDropdownId(null);
                                              updateInvoiceOnBackend(order, { paymentType: method });
                                            }}
                                            className={`px-4 py-2 text-[14px] font-bold uppercase transition-all ${selectedPayment.find((item) => item.OID === order.OID)?.payment === method
                                              ? "text-primary-600 bg-primary-50"
                                              : "text-gray-600 hover:bg-gray-50"
                                              }`}
                                          >
                                            {method}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Product List & Billing (Always Visible) */}
                            <div className="my-2 medicine-table" id={`order-details-${order?.OID}`} ref={detailsRef}>
                              {order?.orderProducts?.length > 0 ? (
                                <div className="space-y-1 overflow-y-auto pr-1 thin-scrollbar">
                                  {[...(order?.orderProducts || [])]
                                    .sort((a, b) => (Number(a.id) || 0) - (Number(b.id) || 0))
                                    .map((product, pIdx) => {
                                      const rowTags = getProductRowTags(product, products, nrxDrugNames);
                                      return (
                                        <div key={pIdx} className={`flex items-center justify-between py-1.5 px-3 rounded-[10px] border transition-colors ${
                                          product?.isReturn
                                            ? "bg-rose-50 border-rose-200 text-rose-900"
                                            : "bg-primary-50 border-primary-100 hover:bg-primary-100/50"
                                        }`}>
                                          <div className="text-[13px] font-bold text-gray-800 flex-1 min-w-0 mr-2">
                                            <div className="flex items-center gap-1.5 flex-wrap">
                                              <span className={`w-8 h-5 flex items-center justify-center rounded-full text-[13px] font-extrabold shrink-0 ${
                                                product?.isReturn
                                                  ? "bg-rose-100 text-rose-700 border border-rose-300"
                                                  : "bg-white text-primary-600 border border-primary-300"
                                              }`}>
                                                {product?.isReturn ? `-${product?.orderQty || 0}` : (product?.orderQty || 0)}
                                              </span>
                                              <span
                                                onClick={() => copyToClipboard(product?.productName, "Product Name")}
                                                className={`truncate max-w-[200px] cursor-pointer transition-all active:scale-95 ${
                                                  product?.isReturn ? "hover:text-rose-700 text-rose-900" : "hover:text-primary-600 text-gray-800"
                                                }`}
                                                title="Click to copy Product Name"
                                              >
                                                {product?.productName || "Product"}
                                              </span>
                                              {product?.isReturn ? (
                                                <span className="text-[9px] px-1.5 py-0.5 rounded-full font-black uppercase tracking-widest bg-rose-100 text-rose-700 border border-rose-200 shrink-0">
                                                  Returned Product
                                                </span>
                                              ) : product?.isCustom ? (
                                                <span className="text-[9px] px-1.5 py-0.5 rounded-full font-black uppercase tracking-widest bg-amber-100 text-amber-700 border border-amber-200 shrink-0">
                                                  Custom
                                                </span>
                                              ) : null}

                                              {/* Product and Drug Tags (Deduplicated) */}
                                              {rowTags.length > 0 && (
                                                <div className="flex items-center gap-1 flex-wrap">
                                                  {rowTags.map((tag, tIdx) => {
                                                    const isNRx = tag.name?.toUpperCase()?.includes("NRX");
                                                    return (
                                                      <span
                                                        key={tag.id || `${tag.name}-${tIdx}`}
                                                        className={`inline-flex items-center px-1.5 py-0.5 rounded-[4px] text-[10px] font-bold tracking-tight border shrink-0 ${
                                                          isNRx
                                                            ? "bg-red-50 text-red-700 border-red-200"
                                                            : "border-black/5"
                                                        }`}
                                                        style={
                                                          !isNRx
                                                            ? {
                                                                backgroundColor: `${tag.color || "#3B82F6"}18`,
                                                                color: tag.color || "#1D4ED8",
                                                                borderColor: `${tag.color || "#3B82F6"}40`,
                                                              }
                                                            : {}
                                                        }
                                                        title={tag.source ? `${tag.name} (${tag.source === "drug" ? "Drug Tag" : "Product Tag"})` : tag.name}
                                                      >
                                                        {tag.name}
                                                      </span>
                                                    );
                                                  })}
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                          <div className={`text-[12px] font-semibold flex items-center gap-1 shrink-0 ${
                                            product?.isReturn ? "text-rose-700" : "text-primary-700"
                                          }`}>
                                            ₹{product?.mrp || 0} <span className="opacity-60">•</span> {product?.discount || 0}% <span className="opacity-60">•</span>
                                            <div className="flex items-center gap-0.5 opacity-70">
                                              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" /></svg>
                                              {product?.qty || 0}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              ) : null}
                            </div>

                            {/* Billing Summary Box */}
                            <div className="border border-primary-100 px-3 py-1.5 rounded-lg bg-white shadow-sm mb-1">
                              <div className="flex flex-col gap-0.5">
                                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-y-1">
                                  <h4 className="text-primary-700 font-bold text-[16px] flex items-center gap-2">
                                    ~Net: ₹{order?.billing?.payableAmount}
                                    <span className="text-gray-500 text-[13px] font-semibold flex items-center gap-1">
                                      (₹{order?.billing?.subTotal})
                                    </span>
                                    <span className="text-success-600 text-[13px] font-semibold flex items-center gap-1">
                                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="shrink-0">
                                        <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                                        <line x1="7" y1="7" x2="7.01" y2="7" />
                                      </svg>
                                      ₹{order?.billing?.totalDiscount} off
                                    </span>
                                    {(() => {
                                      const returnAmt = Number(order?.billing?.totalReturnAmount) ||
                                        (order?.orderProducts || []).filter(p => p.isReturn).reduce((acc, rp) => {
                                          const mrp = Number(rp.mrp) || 0;
                                          const qty = Number(rp.orderQty) || 0;
                                          const disc = Number(rp.discount) || 0;
                                          const unit = disc > 0 ? (mrp - (mrp * disc) / 100) : mrp;
                                          return acc + (unit * qty);
                                        }, 0);
                                      return returnAmt > 0 ? (
                                        <span className="text-rose-700 text-[12px] font-extrabold flex items-center gap-1 bg-rose-50 px-1.5 py-0.5 rounded border border-rose-200">
                                          -₹{parseFloat(returnAmt).toFixed(2)} return
                                        </span>
                                      ) : null;
                                    })()}
                                  </h4>
                                  {order?.isPacked && !order?.isCancelled && (
                                    <div className="flex items-center gap-2 justify-end w-full sm:w-auto pt-1 sm:pt-0 border-t sm:border-0 border-gray-100">
                                      {order?.isPaid ? (
                                        <span className="flex items-center justify-center sm:justify-start gap-1.5 px-3 py-1.5 bg-green-50 text-green-700 font-bold rounded-[8px] text-[12px] border border-green-200 shadow-sm w-full sm:w-auto">
                                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                          Order Paid!
                                        </span>
                                      ) : (
                                        <div className="flex gap-2 items-center w-full sm:w-auto">
                                          {/* <button
                                          type="button"
                                          onClick={() => setPaymentModalInfo({ isOpen: true, orderId: order.OID, amount: (invoiceData[order?.OID]?.invoiceAmount || order?.invoice?.invoiceAmount || order?.billing?.payableAmount || 0) })}
                                          className="px-3 py-1.5 bg-green-500 hover:bg-green-600 text-white font-bold rounded-[8px] text-[11px] transition-all shadow-md active:scale-95 text-center flex items-center justify-center gap-1.5"
                                        >
                                          Make UPI Payment
                                        </button> */}
                                          <button
                                            type="button"
                                            onClick={() => handleMarkAsPaid(order.OID)}
                                            className="px-2.5 py-1.5 bg-green-50 hover:bg-green-400 hover:text-green-900 text-green-700 font-bold rounded-[8px] text-[10px] transition-all border border-green-400 shadow-xs uppercase tracking-wider active:scale-95"
                                          >
                                            Mark as Paid
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                                {(order?.billing?.handlingFee > 0 || order?.billing?.smallCartFee > 0 || order?.billing?.deliveryCharges > 0) && (
                                  <p className="text-gray-400 font-medium text-[12px] flex flex-wrap gap-x-3 gap-y-1">
                                    {order?.billing?.handlingFee > 0 && <span>• Handling: ₹{order?.billing?.handlingFee}</span>}
                                    {order?.billing?.smallCartFee > 0 && <span>• Small Cart: ₹{order?.billing?.smallCartFee}</span>}
                                    {order?.billing?.deliveryCharges > 0 && <span>• Delivery: ₹{order?.billing?.deliveryCharges}</span>}
                                  </p>
                                )}
                              </div>
                            </div>

                            {/* Action Strip */}
                            <div className="flex items-center justify-between gap-3 mt-3 pt-2 border-t border-gray-100">
                              <div className="flex-grow">
                                {(() => {
                                  if (!order.isAccepted && !order.isCancelled) {
                                    return (
                                      <button
                                        type="button"
                                        onClick={() => {
                                          handleCreateLable(order);
                                          handleChangeStatus(order.OID, "Accepted", order);
                                        }}
                                        className="w-full h-[40px] flex items-center justify-center gap-2 text-yellow-700 bg-yellow-50 border-2 border-yellow-400 hover:bg-yellow-100 font-bold text-[14px] rounded-[12px] transition-all active:scale-[0.98] shadow-sm"
                                      >
                                        <CheckedBg fill="currentColor" />
                                        Accept Order
                                      </button>
                                    );
                                  } else if (!order.isCancelled && order.isAccepted && !order.isPacked) {
                                    return (
                                      <button
                                        type="button"
                                        onClick={() => handleChangeStatus(order.OID, "Packed", order)}
                                        className="w-full h-[40px] flex items-center justify-center gap-2 text-teal-700 bg-teal-50 border-2 border-teal-500 hover:bg-teal-100 font-bold text-[14px] rounded-[12px] transition-all active:scale-[0.98] shadow-sm"
                                      >
                                        <Packed fill="currentColor" />
                                        Mark as Packed
                                      </button>
                                    );
                                  } else if ((order?.isClinic || order?.isAddress) && !order.isCancelled && order.isPacked && !order.isDispatched) {
                                    return (
                                      <button
                                        type="button"
                                        onClick={() => handleChangeStatus(order.OID, "Dispatched", order)}
                                        className="w-full h-[40px] flex items-center justify-center gap-2 text-indigo-700 bg-indigo-50 border-2 border-indigo-500 hover:bg-indigo-100 font-bold text-[14px] rounded-[12px] transition-all active:scale-[0.98] shadow-sm"
                                      >
                                        <Shipping fill="currentColor" />
                                        Mark as Dispatched
                                      </button>
                                    );
                                  } else if ((order?.isClinic || order?.isAddress) && !order.isCancelled && order.isDispatched && !order.isDelivered) {
                                    return (
                                      <button
                                        type="button"
                                        onClick={() => handleChangeStatus(order.OID, "Delivered", order)}
                                        className="w-full h-[40px] flex items-center justify-center gap-2 text-success-700 bg-success-50 border-2 border-success-600 hover:bg-success-100 font-bold text-[14px] rounded-[12px] transition-all active:scale-[0.98] shadow-sm"
                                      >
                                        <DobbleCheck fill="currentColor" />
                                        Mark as Delivered
                                      </button>
                                    );
                                  } else if (order?.isCollect && !order.isCancelled && order.isAccepted && order.isPacked && !order.isCollected) {
                                    return (
                                      <button
                                        type="button"
                                        onClick={() => handleChangeStatus(order.OID, "collected", order)}
                                        className="w-full h-[40px] flex items-center justify-center gap-2 text-success-700 bg-success-50 border-2 border-success-600 hover:bg-success-100 font-bold text-[14px] rounded-[12px] transition-all active:scale-[0.98] shadow-sm"
                                      >
                                        <Packed fill="currentColor" />
                                        Mark as Collected
                                      </button>
                                    );
                                  } else if (!order.isCancelled && (order.isDelivered || order.isCollected)) {
                                    return (
                                      <div className="w-full h-[40px] flex items-center justify-center gap-2 text-success-600 bg-success-50 font-bold text-[14px] rounded-[12px] border-2 border-success-100">
                                        <Complete fill="currentColor" />
                                        Order Completed
                                      </div>
                                    );
                                  }
                                })()}
                              </div>

                              <div className="flex items-center gap-2">
                                {states?.isViewLabel && (
                                  <button type="button" onClick={() => handleCreateLable(order)} className="h-10 px-4 flex items-center gap-2 text-[12px] font-bold text-gray-600 bg-gray-50 hover:bg-gray-100 rounded-xl border border-gray-200 transition-colors" title="Print Label">
                                    <CreateOrder fill="currentColor" /> Label
                                  </button>
                                )}
                                {(!order?.isCancelled && !(order?.isDelivered || order?.isCollected)) && (
                                  <button type="button" onClick={() => handleEditOrder(order)} className="w-10 h-10 flex items-center justify-center text-gray-600 bg-gray-50 hover:bg-gray-100 rounded-xl border border-gray-200 transition-colors" title="Edit Order">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                                  </button>
                                )}
                                <button type="button" onClick={() => handleViewImage(order)} className={`w-10 h-10 flex items-center justify-center rounded-xl border transition-all ${order?.filePath?.length > 0 || order?.pdfPath?.length > 0 || order?.qoUploadUrl?.length > 0 ? "text-red-600 bg-red-50 border-red-100 hover:bg-red-100" : "text-gray-300 bg-gray-50 border-gray-100 pointer-events-none"}`} title="Open Prescription">
                                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" /><polyline points="14 2 14 8 20 8" /><path d="M9 13h6" /><path d="M9 17h3" /></svg>
                                </button>
                                {!(order?.isDelivered || order?.isCollected || order?.isCancelled) && (
                                  <button type="button" onClick={() => setOrderToCancel(order)} className="w-10 h-10 flex items-center justify-center text-gray-500 bg-white hover:text-red-600 hover:bg-red-50 rounded-xl border border-gray-100 hover:border-red-100 transition-all font-bold" title="Cancel Order">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></svg>
                                  </button>
                                )}
                              </div>
                            </div>

                            {order.isCancelled && (
                              <div className="mt-4 flex items-center text-[13px] gap-4 bg-red-50 border border-red-100 py-3 px-4 rounded-xl">
                                <span className="text-red-600 font-bold uppercase tracking-tight">Cancelled</span>
                                <div className="w-px h-4 bg-red-200"></div>
                                <span className="text-red-700 font-medium italic">{order?.cancelReason || "No reason provided"}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="col-span-12 py-10 text-center">
                    <p className="text-gray-400 font-medium">No orders found</p>
                  </div>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {filteredData?.orders?.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPreviousPage={handlePreviousPage}
          onNextPage={handleNextPage}
          isPreviousDisabled={currentPage === 1}
          isNextDisabled={currentPage === totalPages}
          itemLength={filteredData?.orders?.length || filteredData?.length}
          totalItems={filteredData?.totalItems || data?.totalItems}
        />
      )}
      {/* Delivery Address Modal */}
      {selectedAddressOrder && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 transition-opacity animate-in fade-in duration-300">
          <div className="bg-white rounded-[16px] w-[95%] max-w-[500px] overflow-hidden shadow-2xl animate-in zoom-in-95 duration-200">
            <div className="bg-primary-50 px-6 py-4 flex items-center justify-between border-b border-primary-100">
              <div className="flex items-center gap-3">
                <div className="bg-primary-600 p-2 rounded-[8px] text-white">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>
                </div>
                <h3 className="font-bold text-primary-800 text-[18px]">Delivery Address</h3>
              </div>
              <button
                onClick={() => setSelectedAddressOrder(null)}
                className="text-secondry-400 hover:text-black transition-colors"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
              </button>
            </div>
            <div className="p-8">
              <div className="space-y-6">
                <div className="pb-4 border-b border-primary-50">
                  <span className="text-[11px] font-black text-primary-300 uppercase tracking-widest block mb-2">Order For</span>
                  <p className="text-[20px] font-bold text-black-lose">
                    {selectedAddressOrder?.patientDetail?.name} {selectedAddressOrder?.patientDetail?.surname}
                  </p>
                  <p className="text-secondry-500 font-medium">
                    {selectedAddressOrder?.patientDetail?.phoneNumber}
                  </p>
                </div>

                <div>
                  <span className="text-[11px] font-black text-primary-300 uppercase tracking-widest block mb-2">Full Address</span>
                  <div className="p-4 bg-primary-50 border border-primary-100 rounded-[12px]">
                    <p className="text-[16px] text-secondry-700 font-semibold leading-relaxed">
                      {[
                        selectedAddressOrder?.addressType,
                        selectedAddressOrder?.premisesNoFloor ? `Floor ${selectedAddressOrder?.premisesNoFloor}` : "",
                        selectedAddressOrder?.premisesName,
                        selectedAddressOrder?.landmark ? `Nr. ${selectedAddressOrder?.landmark}` : "",
                        selectedAddressOrder?.areaRoad,
                        selectedAddressOrder?.city,
                        selectedAddressOrder?.state,
                        selectedAddressOrder?.pincode
                      ].filter(Boolean).join(", ")}
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 pt-2">
                  <div className="p-3 bg-white border border-primary-100 rounded-[8px]">
                    <span className="text-[10px] font-black text-primary-300 uppercase tracking-widest block mb-1">Type</span>
                    <p className="font-bold text-primary-700 capitalize">{selectedAddressOrder?.addressType || "Home"}</p>
                  </div>
                  <div className="p-3 bg-white border border-primary-100 rounded-[8px]">
                    <span className="text-[10px] font-black text-primary-300 uppercase tracking-widest block mb-1">City/Pin</span>
                    <p className="font-bold text-primary-700">{[selectedAddressOrder?.city, selectedAddressOrder?.pincode].filter(Boolean).join(" - ") || "-"}</p>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <button
                  onClick={() => setSelectedAddressOrder(null)}
                  className="w-full bg-primary-600 hover:bg-primary-700 text-white font-bold py-3.5 rounded-[12px] transition-all transform active:scale-[0.98] shadow-lg shadow-primary-200"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Cancel Order Modal */}
      {orderToCancel && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-[2px] transition-all animate-in fade-in duration-300">
          <div className="bg-white rounded-[24px] w-[95%] max-w-[440px] overflow-hidden shadow-2xl animate-in zoom-in-95 duration-200 border border-gray-100">
            <div className="px-8 pt-8 pb-6 text-center">
              <div className="w-16 h-16 bg-red-50 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4 border border-red-100">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
              </div>
              <h3 className="text-[22px] font-bold text-gray-900 mb-2">Cancel Order?</h3>
              <p className="text-gray-500 text-[15px] leading-relaxed">
                Please provide a reason to cancel <b>Order #{orderToCancel?.OID}</b>. This action cannot be undone.
              </p>
            </div>

            <div className="px-8 pb-8">
              <div className="mb-6">
                <label className="block text-[12px] font-bold text-gray-400 uppercase tracking-widest mb-2 ml-1">Cancellation Reason</label>
                <textarea
                  className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-red-500 transition-all outline-none text-[15px] resize-none"
                  rows="3"
                  placeholder="e.g. Out of stock, Patient requested..."
                  value={cancelReason}
                  onChange={(e) => setCancelReason(e.target.value)}
                />
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setOrderToCancel(null);
                    setCancelReason("");
                  }}
                  className="flex-1 h-12 text-[15px] font-bold text-gray-500 hover:bg-gray-100 rounded-xl transition-colors"
                >
                  Go Back
                </button>
                <button
                  onClick={finalHandleConfirmCancel}
                  className="flex-1 h-12 text-[15px] font-bold text-white bg-red-600 hover:bg-red-700 rounded-xl transition-all shadow-lg shadow-red-100 active:scale-[0.98]"
                >
                  Cancel Order
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <UPIPaymentModal
        isOpen={paymentModalInfo.isOpen}
        amount={paymentModalInfo.amount}
        orderId={paymentModalInfo.orderId}
        onClose={() => setPaymentModalInfo({ isOpen: false, orderId: null, amount: 0 })}
        onPaymentSuccess={() => {
          setFilteredData((prevState) => {
            return {
              ...prevState,
              orders: prevState?.orders?.map((order) => {
                if (order?.OID === paymentModalInfo.orderId) {
                  return { ...order, isPaid: true };
                }
                return order;
              }),
            };
          });
        }}
      />

      <ConfirmationModal
        isOpen={confirmModalState.isOpen}
        title="Mark Order as Paid?"
        message={`This correctly overrides the current payment intent limits locking the order to Paid status for further dispatches. You cannot undo this easily.`}
        onConfirm={executeMarkAsPaid}
        onCancel={() => setConfirmModalState({ isOpen: false, orderId: null })}
      />
    </section>
  );
}

export default Orders;
